// Note: The first file of a module here, must also register the module

import "./data-record-dialog.component";
import "./data-record-message.component";
import "./data-record.helper";
